/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Permonth1Inputs */

const zh_pricing_permonth1 = /** @type {(inputs: Pricing_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mo`)
};

const en_pricing_permonth1 = /** @type {(inputs: Pricing_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mo`)
};

const es_pricing_permonth1 = /** @type {(inputs: Pricing_Permonth1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

/**
* | output |
* | --- |
* | "/mo" |
*
* @param {Pricing_Permonth1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const pricing_permonth1 = /** @type {((inputs?: Pricing_Permonth1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Permonth1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_permonth1(inputs)
	if (locale === "en") return en_pricing_permonth1(inputs)
	return es_pricing_permonth1(inputs)
});
export { pricing_permonth1 as "pricing_perMonth" }